import { useState } from "react";
import { FiSettings } from "react-icons/fi";

const MyBusinessListingOptions = () => {
  const [show, setShow] = useState(false);
  return (
    <div className="relative flex flex-col items-end justify-start pr-6 pt-5">
      <div
        className="flex h-10 w-10 cursor-pointer items-center justify-center bg-primary"
        onClick={() => setShow((prevState) => !prevState)}
      >
        <FiSettings className="h-[22px] w-[22px] text-white" />
      </div>
      {show && (
        <div className="absolute top-[60px] right-6 z-10 flex flex-col gap-2.5 border border-primary bg-quantityColor p-2.5">
          <p className="cursor-pointer font-pop text-base font-medium text-darkGreen">
            View Listing
          </p>
          <p className="cursor-pointer font-pop text-base font-medium text-darkGreen text-opacity-[.36]">
            Renew
          </p>
          <p className="cursor-pointer font-pop text-base font-medium text-darkGreen">
            Edit
          </p>
          <p className="cursor-pointer font-pop text-base font-medium text-darkGreen">
            Delete
          </p>
        </div>
      )}
    </div>
  );
};

export default MyBusinessListingOptions;
